import { render, staticRenderFns } from "./RegulationReviewCard.vue?vue&type=template&id=a087c33a&scoped=true&"
import script from "./RegulationReviewCard.vue?vue&type=script&lang=js&"
export * from "./RegulationReviewCard.vue?vue&type=script&lang=js&"
import style0 from "./RegulationReviewCard.vue?vue&type=style&index=0&id=a087c33a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a087c33a",
  null
  
)

export default component.exports